import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export default function Footer() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100vw",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        pb: 2,
        pt: 2,
        backgroundColor: "#ffffff",
        boxShadow: "unset",
      }}
    >
      <Typography variant="body2" align="center">
        <span style={{ color: "#7e7e7e" }}>
          All Rights Reserved ©{new Date().getFullYear()} -
        </span>{" "}
        <span
          style={{ color: theme.palette.primary.secondary, fontWeight: "600" }}
        >
          Karyadata
        </span>
      </Typography>
    </Box>
  );
}
